module.exports = __webpack_public_path__ + "static/media/config-gear-icon.33a5dcd4.svg";